// extracted by mini-css-extract-plugin
export var attribution = "_9u-4";
export var authorName = "_9u-5";
export var quote = "_9u-3";
export var testimonial = "_9u-2";
export var trustedBy = "_9u-0";
export var trustedByLabel = "_9u-1";